import React from 'react';
import { useLocation } from 'react-router-dom';
import * as env from 'config/environment';
import { useCustomHeaderTitle } from 'hooks/useCustomHeaderTitle';

export const TargetPremium = () => {
  useCustomHeaderTitle('資産目標サポート');
  const { pathname } = useLocation();
  const linkDo = `${env.premiumURL}?service=${
    env.serviceName
  }&utm_source=tw_minkabu&utm_medium=target&utm_campaign=target_202407&callback_url=${encodeURI(
    `${env.appURL}/auth?callbackPath=${pathname}`
  )}`;

  return (
    <>
      <div className="flex flex-col bg-teal-500" style={{ height: '410px' }}>
        <div className="mt-6 text-34 text-white font-bold text-center">
          目標資金<span className="text-28">を</span>
          <br />
          AI<span className="text-28">と</span>貯める！
        </div>
        <div className="relative flex justify-center mt-4">
          <img
            src="/static/images/premium/target_image_premium.png"
            alt=""
            className="absolute"
            style={{ top: '0%' }}
          />
        </div>
      </div>
      <div className="flex flex-col bg-white">
        <div className="flex flex-row items-center justify-center mt-12">
          <div className="mr-1 text-lg font-bold text-teal-500">
            こんな方におすすめ
          </div>
          <img src="/static/images/premium/denkyu.svg" alt="" />
        </div>
        <div className="flex flex-col pb-16 items-center">
          <div className="text-base text-bluegray-700 font-bold">
            <div className="flex flex-row mt-3">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">老後資金、FIRE資金などを貯めたい</div>
            </div>
            <div className="flex flex-row mt-3">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">投資をシミュレーションしたい</div>
            </div>
            <div className="flex flex-row mt-3">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">目標金額が貯まっているか知りたい</div>
            </div>
          </div>
        </div>
      </div>
      {/* PC */}
      <div
        className="lg:block hidden sticky w-full bg-white px-2 pb-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div className="flex flex-row pt-2 pb-1 justify-center text-sm font-bold app-primary-label-block">
          みんかぶプレミアム初回30日間無料
        </div>
        <div className="flex justify-center">
          <a href={linkDo} target="_self">
            <div className="max-w-full flex flex-col py-3 px-24 mx-auto justify-center text-lg font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75">
              <div className="">今すぐ使ってみる</div>
            </div>
          </a>
        </div>
      </div>
      {/* SP */}
      <div
        className="lg:hidden block fixed w-full bg-white px-2 pb-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div className="flex flex-row pt-2 pb-1 justify-center text-sm font-bold app-primary-label-block">
          みんかぶプレミアム初回30日間無料
        </div>
        <a href={linkDo} target="_self">
          <div className="max-w-full flex flex-col py-3 items-center justify-center text-lg font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75">
            <div className="">今すぐ使ってみる</div>
          </div>
        </a>
      </div>
    </>
  );
};
